import PropTypes from "prop-types";
import { useEffect } from "react";
import { useParams } from "react-router";

import DetaljPageHeader from "../../../Common/Detalj/DetaljPageHeader";
import GridTable from "../../../Common/GridTable";
import BilderContainer from "./BilderContainer";
import EndreMiljokontrollContainer from "./EndreMiljokontrollContainer";
import MakulerMiljokontrollContainer from "./MakulerMiljokontrollContainer";
import MiljokontrollKommentarerContainer from "./MiljokontrollKommentarerContainer";
import OpphevMakuleringMiljokontrollContainer from "./OpphevMakuleringMiljokontrollContainer";

import { bypatruljen } from "../../../../constants/roles";
import { tidskontrollDetalj as tidskontrollDetaljTitle } from "../../../../constants/titles";
import { authorized } from "../../../../utils/authorizationUtils";
import Historikk from "./Historikk";

export default function MiljokontrollDetalj({
  miljokontroll,
  miljokontrollGridTableRows,
  getMiljokontroll,
}) {
  const { id } = useParams();

  useEffect(() => {
    document.title = tidskontrollDetaljTitle("");
    window.scrollTo(0, 0);
    getMiljokontroll(id);
  }, [id]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    document.title =
      miljokontroll && miljokontroll.nummer
        ? tidskontrollDetaljTitle(miljokontroll.nummer)
        : tidskontrollDetaljTitle("");
  }, [miljokontroll]);

  if (!miljokontroll || !miljokontrollGridTableRows) {
    return <></>;
  }

  const nummer = miljokontroll.nummer ? miljokontroll.nummer.toString() : "";

  return (
    <>
      <DetaljPageHeader
        pageName="Tidskontroll"
        pageId={nummer}
        isMakulert={miljokontroll.deaktivertDato}
        makulertTekst="Lukket"
      />
      {authorized([
        bypatruljen.saksbehandler,
        bypatruljen.saksbehandleradmin,
      ]) &&
        miljokontroll &&
        miljokontroll.deaktivertDato &&
        !miljokontroll.miljogebyrId && (
          <section
            style={{
              float: "right",
              marginLeft: 50,
              marginTop: 0,
              marginRight: 50,
              marginBottom: 20,
            }}
          >
            <OpphevMakuleringMiljokontrollContainer />
          </section>
        )}
      {authorized([
        bypatruljen.saksbehandler,
        bypatruljen.saksbehandleradmin,
      ]) &&
        miljokontroll &&
        !miljokontroll.deaktivertDato && (
          <section
            style={{
              float: "right",
              marginLeft: 50,
              marginTop: 0,
              marginRight: 50,
              marginBottom: 20,
            }}
          >
            <MakulerMiljokontrollContainer />
            <EndreMiljokontrollContainer />
          </section>
        )}
      <section>
        <GridTable
          name="detaljMiljokontroll"
          rows={miljokontrollGridTableRows}
        />
        <div
          className="detalj-ileggelse-kommentarerer"
          style={{ marginTop: 15, marginLeft: 50 }}
        >
          <h5>Internkommentar</h5>
          <p>{miljokontroll.kommentar || "-"}</p>
        </div>
      </section>
      <section>
        <MiljokontrollKommentarerContainer miljokontrollId={id} />
      </section>
      <section
        style={{ paddingRight: 50, paddingBottom: 50, paddingLeft: 50 }}
      >
        <BilderContainer id={id} />
      </section>
      <section
        style={{ paddingRight: 50, paddingBottom: 50, paddingLeft: 50 }}
      >
        <Historikk miljoKontrollId={id} />
      </section>
    </>
  );
}

MiljokontrollDetalj.propTypes = {
  miljokontroll: PropTypes.object,
  miljokontrollGridTableRows: PropTypes.arrayOf(
    PropTypes.arrayOf(PropTypes.object)
  ),
  getMiljokontroll: PropTypes.func,
};
